export const ACCOUNT_INACTIVE_MESSAGE = "アカウントがアクティブでないためログインできません";

export const buildLoginError = (error) => {
  const status = error?.response?.status;
  const data = error?.response?.data;

  if (status === 403 && data?.error === "account_inactive") {
    return { code: "account_inactive", message: ACCOUNT_INACTIVE_MESSAGE };
  }

  return { code: "unknown", message: null };
};
